import React, { useCallback } from 'react';
import { ReactComponent as UserIcon } from 'assets/icons/user-icon.svg';
import tel from 'utils/phone';
import { FormatPrice } from 'utils/format';
import { ServiceTagFleetService, ServiceTagFTC } from 'components/ServiceTag';
import {
  DispatchingFiltersContextProvider,
  useFiltersHook,
} from '../../dispatching/filters/context';
import { Icon } from '@ontruck/orc';

const t = {
  call: 'Call the driver',
  assign: 'Accept this bid',
};

const ListItem = ({ disabled, bid, onCallClick, onAssignClick, isRejected }) => {
  const handleAssignment = useCallback(() => {
    onAssignClick(bid);
  }, [onAssignClick, bid]);

  const handleCall = useCallback(() => {
    onCallClick(bid);
  }, [onCallClick, bid]);

  const { filters } = useFiltersHook();
  const isAuto = !filters?.need_manual_dispatching;

  return (
    <>
      <div className="list_item" disabled={disabled}>
        <div className="name">
          <div className="name_content">
            {!bid?.viewed && <span className="not_viewed" />}
            {bid?.driver_name}&nbsp;
            {bid?.is_ftc && <ServiceTagFTC size="S" />}
            {bid?.is_fleet_service && <ServiceTagFleetService size="S" />}
          </div>
        </div>
        <div className="scoring">{(bid?.scoring * 100).toFixed(0)}%</div>
        <div className="bid" style={{ textDecoration: isRejected ? 'line-through' : '' }}>
          <FormatPrice currency={bid?.currency} value={bid?.cost} />
        </div>
        <div className="bid">
          <FormatPrice currency={bid?.currency} value={bid?.margin} />
        </div>

        {!isRejected && !isAuto && (
          <div>
            <button
              className="actions"
              onClick={handleAssignment}
              title={t.assign}
              data-testid="assignment-button"
            >
              <UserIcon />
            </button>
          </div>
        )}

        {!isAuto && (
          <div>
            <a
              className="actions"
              onClick={handleCall}
              href={tel(bid?.driver_phone)}
              title={t.call}
              data-testid="phone-button"
            >
              <Icon glyph="phone" size="1.8rem" color="white" />
            </a>
          </div>
        )}
      </div>
    </>
  );
};

const BiddingListItem = (props) => {
  return (
    <DispatchingFiltersContextProvider>
      <ListItem {...props} />
    </DispatchingFiltersContextProvider>
  );
};

export default BiddingListItem;
